import {Vue, Component, Prop} from "vue-property-decorator";
import EventBus from "../../helpers/eventbus";
import BrowserStorage from "../../helpers/browser-storage";

@Component
export default class CookieBanner extends Vue {

    @Prop({type: Boolean, default: true}) public isProduction: boolean;

    cookieNameType = 'hasAnalyticsConsent';
    trackingAllowed = false;
    isBot = false;

    created() {

        this.isBot = /bot|googlebot|crawler|facebookexternalhit|spider|robot|crawling/i.test(navigator.userAgent);

        this.trackingAllowed = (!this.isBot && !this.doNotTrack() && this.cookiesCanBeSet());

        //@ts-ignore
        EventBus.$on('cookieConsent', (payload) => {
            if (payload[this.cookieNameType]) {
                this.launch();
            } else {
                this.destroy();
            }
        });
    }

    /**
     * EVERY STATISTICS SCRIPTS COME HERE
     */

    launch() {
        if (this.isProduction && this.trackingAllowed) {
            /**
             * INSERT ALL TRACKING CODE HERE
             */

            //Google Analytics
            const script = document.createElement('script');
            script.innerHTML = `window.dataLayer = window.dataLayer || [];
                               (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');ga('create', 'UA-111444177-1', 'auto');ga('send', 'pageview');`;
            document.body.appendChild(script);

        } else {
            console.log("Tracking not allowed because at least one of the following is true. is Author:" + !this.isProduction + ", do Not Track: " + this.doNotTrack() + ", isBot: "+this.isBot)
        }
    }

    destroy () {
        // Remove all component-specific Cookies
        console.log("Remove all Google Analytics cookies");
        BrowserStorage.clearCookiesStartWith('_ga'); // Google Analytics
        // BrowserStorage.clearCookiesStartWith('_gat'); // Google Analytics
        BrowserStorage.clearCookiesStartWith('_gid'); // Google Analytics
        BrowserStorage.clearCookiesStartWith('_gcl_au'); // GTM's Conversion Linker, set Google Tracking on 1st party
    }

    doNotTrack() {
        const dnt = navigator.doNotTrack || window.doNotTrack;
        const canTrack = (dnt !== null && dnt !== undefined) ? (dnt && dnt !== 'yes' && dnt !== '1') : true;

        return !(canTrack);
    }

    cookiesCanBeSet() {
        const cookieEnabled = navigator.cookieEnabled;

        // When cookieEnabled flag is present and false then cookies are disabled.
        if (!cookieEnabled) {
            return false;
        } else {
            // try to set a test cookie if we can't see any cookies and we're using
            // either a browser that doesn't support navigator.cookieEnabled
            // or IE (which always returns true for navigator.cookieEnabled)
            if (!document.cookie) {
                document.cookie = "hasCookieEnabled";

                if (!document.cookie) {
                    return false;
                } else {
                    BrowserStorage.deleteCookie("hasCookieEnabled");
                    return true;
                }
            }
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/components/scripts/tag-manager.ts